export function taskActivitiesQueryKey(taskId: string) {
  return ['task-activities', taskId] as const;
}
